/**
 * Like Listener - Event Listener Registration
 * Registers event listeners and delegates to handler
 */

import { getEventScope } from "../core/event-scope/event-scope";
import { Roles } from "../constants/roles";

interface LikeHandlerLike {
    handleLike(button: HTMLElement): Promise<void>;
}

class LikeListener {
    public handler: LikeHandlerLike;

    public constructor(handler: LikeHandlerLike) {
        this.handler = handler;
    }

    public setup(): void {
        const scope = getEventScope(document, "like");

        scope.once("like-click", () => {
            scope.delegate("click", `[data-role="${Roles.LIKE_BUTTON}"]`, async (event: Event, likeBtnEl: Element) => {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();
                if (!(likeBtnEl instanceof HTMLElement)) {
                    return;
                }
                await this.handler.handleLike(likeBtnEl);
            });
        });
    }
}

export { LikeListener };
